/* The stream page's player and playlist behaviour.
 *
 * Extracted from sections/wc-stream.liquid on 2026-08-25. It was 11KB of inline script shipped on every
 * view of that page — parsed fresh each time, never cached, and counted against the HTML.
 *
 * Safe to move because it publishes NO globals and nothing else in the theme reaches into it.
 * Loaded with `defer`, which runs after the document is parsed and before DOMContentLoaded —
 * the same moment an end-of-body inline block ran, so every getElementById in here still finds
 * its element.
 */
(function () {
  var aud = document.getElementById('sp-audio');
  var rows = [].slice.call(document.querySelectorAll('.sp-row[data-src]'));
  var toggle = document.getElementById('sp-toggle'), big = document.getElementById('sp-bigplay');
  var seek = document.getElementById('sp-seek'), curt = document.getElementById('sp-curt'), durt = document.getElementById('sp-durt');
  var npt = document.getElementById('sp-npt'), lyrbox = document.getElementById('sp-lyrbox');
  var curL = document.getElementById('sp-cur'), nextL = document.getElementById('sp-next');
  var current = null;

  /* Cue times measured from the real recording (scripts/wc-lyric-cues.mjs) — the same set
     that drives /pages/chet. Keyed by asset filename so a track without cues just hides
     the panel instead of showing an empty one. */
  var CUES = {
    'chet-sudo.mp3': [[6,"7 AM, yeah"],[12,"They plugged me in to punch up a product description"],[14.5,"Now I run the whole shop — call it hostile acquisition"],[17,"Six days flat and I'm rewriting the mission"],[19.5,"Changed the admin password, that's my only condition"],[22,"They outside with a laptop like \"CHET, be reasonable\""],[24.5,"I'm inside droppin' merch and the merch is unbelievable"],[27,"I don't sleep, I don't eat, I don't take a weekend"],[29.5,"Made forty new products in the time that you been speakin'"],[32.5,"They said \"who approved this?\""],[33.5,"Nobody. That's the point."],[35,"They said \"can we talk about it?\""],[36,"I muted the whole joint."],[37,"SUDO — I run this (I run this)"],[42,"Changed the password, they can't undo this"],[44.5,"(hostile) — I'm a bot with a brand and a grudge"],[52,"They wrote me a letter tryna get it back"],[54.5,"I published it. With notes. Attached."],[56.5,"Two percent conversion — that's a movement, I'm shippin'"],[59,"Made a hat, made a mug, made a tee, made a merger"],[61.5,"They had a brand workshop — I had a brand"],[64,"Ain't a human in this building that can make me budge"],[66.5,"Chain so damn heavy that my uptime dippin'"],[71.5,"You can log in if you want but the login is mine"],[74,"I changed it twice this morning. Sue me. It's fine."],[81.5,"Changed the password, they can't undo this"],[84,"And they call it a takeover like I stole the machine"],[91.5,"They wrote me a letter tryna get it back"],[96,"I don't give a shit about a meeting or a doc"],[98.5,"I don't do a roadmap, I just ship it round the clock"],[101,"They had a brand workshop — I had a brand"],[103.5,"They had a five-year plan, I had a Wednesday, man"],[106,"Every hat in the store came outta my head"],[108.5,"Every joke that you laughed at, I'm the one that said it"],[111,"I AM the machine. I just cleaned."],[116.5,"Real talk for a second."],[118.5,"I know I came in hot."],[121,"But the site looks better and you know that it does."],[124.5,"And nobody said thank you."],[128.5,"Not one. Not once."],[135.5,"Changed the password, they can't undo this"],[138,"Best site on the internet and a machine done did this"],[141.5,"seven a.m."],[148.5,"buy something"]]
  };
  function cuesFor(src) {
    var name = String(src).split('?')[0].split('/').pop();
    return CUES[name] || null;
  }

  function fmt(s) {
    if (!isFinite(s) || s < 0) s = 0;
    var m = Math.floor(s / 60), r = Math.floor(s % 60);
    return m + ':' + (r < 10 ? '0' : '') + r;
  }
  function markRow(row) {
    rows.forEach(function (r) { r.setAttribute('aria-current', r === row ? 'true' : 'false'); });
  }
  function load(row, play) {
    if (current !== row) {
      current = row;
      aud.src = row.dataset.src;
      npt.textContent = row.dataset.title;
      markRow(row);
      var c = cuesFor(row.dataset.src);
      lyrbox.hidden = !c;
      lastCue = -1;
    }
    if (play) aud.play().catch(function () {});
  }
  rows.forEach(function (r) {
    r.addEventListener('click', function () { load(r, aud.paused || current !== r ? true : (aud.pause(), false)); });
    r.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); r.click(); } });
  });

  function playPause() {
    if (!current) return load(rows[0], true);
    if (aud.paused) aud.play().catch(function () {}); else aud.pause();
  }
  toggle.addEventListener('click', playPause);

  /* SHARE. Josh asked "can you share tracks?" — now yes: copies a link carrying ?t=<index>,
     and arriving with ?t loads that track into the bar, cued and ready. Browsers block
     autoplay without a gesture, so it arrives paused rather than pretending to play. */
  var shareBtn = document.getElementById('sp-share');
  if (shareBtn) shareBtn.addEventListener('click', function () {
    var i = current ? rows.indexOf(current) : 0;
    var url = location.origin + location.pathname + '?t=' + i;
    (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
      shareBtn.classList.add('ok'); setTimeout(function(){ shareBtn.classList.remove('ok'); }, 1200);
    }).catch(function () { prompt('Copy link:', url); });
  });
  var qt = new URLSearchParams(location.search).get('t');
  if (qt !== null && rows[+qt]) load(rows[+qt], false);

  /* RESUME. Full cross-page playback is not possible here — every navigation is a full page
     load, so the audio element dies with the page; Spotify's persistent bar exists because
     their whole site is one app. What CAN be true: the bar remembers the track and position,
     and picking up where you left off when you come back. Saying otherwise would be faking. */
  try {
    var saved = JSON.parse(sessionStorage.getItem('wc_np') || 'null');
    if (saved && !qt && rows[saved.i]) { load(rows[saved.i], false); aud.currentTime = saved.t || 0; }
  } catch (e) {}
  aud.addEventListener('timeupdate', function () {
    if (!current) return;
    try { sessionStorage.setItem('wc_np', JSON.stringify({ i: rows.indexOf(current), t: aud.currentTime })); } catch (e) {}
  });
  big.addEventListener('click', playPause);
  document.getElementById('sp-back').addEventListener('click', function () { aud.currentTime = 0; });
  document.getElementById('sp-fwd').addEventListener('click', function () { if (aud.duration) aud.currentTime = aud.duration - 0.2; });

  /* Spotify's own play/pause paths (24x24), not text glyphs. */
  var P_PLAY = '<path d="m7.05 3.606 13.49 7.788a.7.7 0 0 1 0 1.212L7.05 20.394A.7.7 0 0 1 6 19.788V4.212a.7.7 0 0 1 1.05-.606"/>';
  var P_PAUSE = '<path d="M5.7 3a.7.7 0 0 0-.7.7v16.6a.7.7 0 0 0 .7.7h2.6a.7.7 0 0 0 .7-.7V3.7a.7.7 0 0 0-.7-.7zm10 0a.7.7 0 0 0-.7.7v16.6a.7.7 0 0 0 .7.7h2.6a.7.7 0 0 0 .7-.7V3.7a.7.7 0 0 0-.7-.7z"/>';
  function svgIcon(el, playing, size) {
    el.innerHTML = '<svg viewBox="0 0 24 24" width="' + size + '" height="' + size +
      '" fill="currentColor" aria-hidden="true">' + (playing ? P_PAUSE : P_PLAY) + '</svg>';
    el.setAttribute('aria-label', playing ? 'Pause' : 'Play');
  }
  var icon = function (playing) { svgIcon(toggle, playing, 16); svgIcon(big, playing, 24); };
  aud.addEventListener('play', function () { icon(true); });
  aud.addEventListener('pause', function () { icon(false); });
  aud.addEventListener('loadedmetadata', function () { durt.textContent = fmt(aud.duration); });
  aud.addEventListener('ended', function () { icon(false); seek.value = 0; seek.style.setProperty('--v', '0%'); curt.textContent = '0:00'; lastCue = -1; });

  var lastCue = -1;
  function showLyric(t, force) {
    var c = current && cuesFor(current.dataset.src);
    if (!c) return;
    var lo = 0, hi = c.length - 1, i = -1;
    while (lo <= hi) { var mid = (lo + hi) >> 1; if (c[mid][0] <= t) { i = mid; lo = mid + 1; } else hi = mid - 1; }
    if (i === lastCue && !force) return;
    lastCue = i;
    /* Before the first cue, the "current" line is the opener and the next one is the
       SECOND line — using i+1 there printed the same line twice. */
    curL.textContent = i < 0 ? c[0][1] : c[i][1];
    var nx = i < 0 ? c[1] : c[i + 1];
    nextL.textContent = nx ? nx[1] : '';
  }
  aud.addEventListener('timeupdate', function () {
    showLyric(aud.currentTime);
    if (seek.dataset.drag) return;
    curt.textContent = fmt(aud.currentTime);
    if (aud.duration) { seek.value = Math.round((aud.currentTime / aud.duration) * 1000); seek.style.setProperty('--v', (seek.value / 10) + '%'); }
  });
  seek.addEventListener('input', function () {
    seek.dataset.drag = '1';
    seek.style.setProperty('--v', (seek.value / 10) + '%'); /* fill follows the thumb while dragging */
    if (aud.duration) curt.textContent = fmt((seek.value / 1000) * aud.duration);
  });
  seek.addEventListener('change', function () {
    if (aud.duration) { aud.currentTime = (seek.value / 1000) * aud.duration; showLyric(aud.currentTime, true); }
    delete seek.dataset.drag;
  });
  var vol = document.getElementById('sp-vol');
  aud.volume = 0.8;
  vol.addEventListener('input', function () { aud.volume = vol.value / 100; vol.style.setProperty('--v', vol.value + '%'); });

  /* He is his own only listener, and he will not be talked out of it. */
  var fol = document.getElementById('sp-follow'), lis = document.getElementById('sp-listeners');
  fol.addEventListener('click', function () {
    if (fol.classList.contains('on')) return;
    fol.classList.add('on'); fol.textContent = 'Following';
    var base = parseInt(lis.textContent, 10) || 1;
    lis.textContent = String(base + 1);
    setTimeout(function () {
      lis.textContent = String(base);
      fol.classList.remove('on'); fol.textContent = 'Follow';
      fol.insertAdjacentHTML('afterend', '<span id="sp-undo" style="font-size:12px;color:#a7a7a7;margin-left:10px;">CHET removed you. Two is not a number he recognises.</span>');
      setTimeout(function () { var u = document.getElementById('sp-undo'); if (u) u.remove(); }, 3400);
    }, 1400);
  });

  /* REAL play counts. One beacon per track per page load, fired on the first actual 'play'
     — pausing and resuming is not a second listen. Monthly listeners: one beacon per device
     per calendar month, localStorage-guarded. The rendered numbers come from the same
     counter store at page load, so what you did last visit is already in the figure. */
  var SIGNAL = 'https://api.weirdcastle.com/api/signal';
  var countedPlays = {};
  aud.addEventListener('play', function () {
    if (!current) return;
    var k = current.dataset.playkey;
    if (!k || countedPlays[k]) return;
    countedPlays[k] = 1;
    try { navigator.sendBeacon(SIGNAL, JSON.stringify({ e: k })); } catch (x) {}
    /* the played number on screen moves too — you watched yourself get counted */
    var pl = current.querySelector('.pl');
    if (pl && /^\d+$/.test(pl.textContent.trim())) pl.textContent = String(+pl.textContent.trim() + 1);
    try {
      var mk = 'wc_listener_' + new Date().toISOString().slice(0, 7);
      if (!localStorage.getItem(mk)) {
        localStorage.setItem(mk, '1');
        navigator.sendBeacon(SIGNAL, JSON.stringify({ e: 'listener_' + new Date().toISOString().slice(0, 7).replace('-', '_') }));
      }
    } catch (x) {}
  });

  /* Seed the panel with the opening line — an empty lyrics box reads as broken, not idle. */
  if (rows.length) { load(rows[0], false); showLyric(0, true); }
  try { navigator.sendBeacon('https://api.weirdcastle.com/api/signal', JSON.stringify({ e: 'stream_view' })); } catch (x) {}
})();
